import React from "react";
import { useHistory } from "react-router";
import { Button, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { TypesCharacteristicsObjectListSearch } from "../../features/TypesCharacteristicsObjectListSearch/TypesCharacteristicsObjectListSearch";
import { TypesCharacteristicsObjectListTable } from "../../features/TypesCharacteristicsObjectListTable/TypesCharacteristicsObjectListTable";
import { hasAccess } from "../../../../components/RolesModule/hasAccess";
import { MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE } from "../../../../lib/const/permissions";
import "./TypesCharacteristicsObjectList.less";

export const TypesCharacteristicsObjectList = () => {
  const history = useHistory();

  return (
    <div className="types-characteristics-object-list">
      <Row justify="space-between">
        <h1>Типы характеристик (объект)</h1>

        {hasAccess(MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE) && (
          <Button
            icon={<PlusOutlined />}
            type="primary"
            className="types-characteristics-object-list__add-btn"
            onClick={() => {
              history.push(`/types-characteristics-object/create`);
            }}
          >
            Создать тип для объекта
          </Button>
        )}
      </Row>
      <TypesCharacteristicsObjectListSearch />
      <TypesCharacteristicsObjectListTable />
    </div>
  );
};
